// extracted by mini-css-extract-plugin
module.exports = {"feature__item":"style_feature__item__2Z9lO"};